// extracted by mini-css-extract-plugin
export default {"loginElem":"login_loginElem__X9OGc","card":"login_card__k0QtU","homeLogo":"login_homeLogo__8KP7c","phoneElem":"login_phoneElem__uUd0Y","isdCode":"login_isdCode__UfQhh"};